import { tickerLines } from "@/mocks/blackmole";

export default function TopTicker() {
  const loop = [...tickerLines, ...tickerLines];
  return (
    <div className="border-b border-background-300/60 bg-foreground-950 text-background-100">
      <div className="mx-auto flex w-full max-w-[1240px] items-center gap-4 px-4 py-2.5 md:px-6">
        <div className="flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-2.5 py-1 text-background-50">
          <i className="ri-flashlight-fill text-xs"></i>
          <span className="whitespace-nowrap text-xs font-semibold">即时更新</span>
        </div>
        <div className="marquee-hover group relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 pr-10">
            {loop.map((line, idx) => (
              <span key={idx} className="whitespace-nowrap text-xs text-background-200/90">
                {line}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden shrink-0 items-center gap-1.5 text-xs text-accent-300 sm:flex">
          <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-accent-400"></span>
          <span className="whitespace-nowrap">实时抓取中</span>
        </div>
      </div>
    </div>
  );
}